/* ============================================================
   DPH Theme — Main JavaScript
   Denver Progressive House
============================================================ */

(function () {
  'use strict';

  /* ---- NAV SCROLL BEHAVIOR ---- */
  var nav = document.getElementById('site-nav');
  if (nav) {
    function handleNavScroll() {
      if (window.scrollY > 40) {
        nav.classList.add('scrolled');
      } else {
        nav.classList.remove('scrolled');
      }
    }
    window.addEventListener('scroll', handleNavScroll, { passive: true });
    handleNavScroll(); // run on load
  }

  /* ---- SHOWS ANCHOR SCROLL ---- */
  // "Shows" nav link scrolls to #shows on home page;
  // if not on home page, it navigates home first.
  var showsLink = document.getElementById('nav-shows');
  if (showsLink) {
    showsLink.addEventListener('click', function (e) {
      var showsSection = document.getElementById('shows');
      if (showsSection) {
        e.preventDefault();
        showsSection.scrollIntoView({ behavior: 'smooth' });
      }
      // else allow default href="/#shows" to work
    });
  }

  /* ---- HERO CTA → SHOWS SCROLL ---- */
  document.querySelectorAll('a[href="#shows"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = document.getElementById('shows');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  /* ---- MERCH CAROUSEL ---- */
  var track      = document.getElementById('carousel-track');
  var prevBtn    = document.getElementById('carousel-prev');
  var nextBtn    = document.getElementById('carousel-next');
  var dotsWrap   = document.getElementById('carousel-dots');

  if (track && prevBtn && nextBtn) {
    var items        = track.querySelectorAll('.carousel-item');
    var totalItems   = items.length;
    var currentIndex = 0;
    var visibleCount = getVisible();
    var dots         = [];

    function getVisible() {
      var w = window.innerWidth;
      if (w <= 480)  return 1;
      if (w <= 768)  return 2;
      if (w <= 1024) return 3;
      return 4;
    }

    function maxIndex() {
      return Math.max(0, totalItems - visibleCount);
    }

    function updateCarousel() {
      var itemWidth   = track.parentElement.offsetWidth / visibleCount;
      var gap         = 22; // matches CSS gap: 1.4rem ≈ 22px
      var offset      = currentIndex * (itemWidth + gap);
      track.style.transform = 'translateX(-' + offset + 'px)';

      prevBtn.style.opacity = currentIndex === 0 ? '0.3' : '1';
      nextBtn.style.opacity = currentIndex >= maxIndex() ? '0.3' : '1';

      dots.forEach(function (dot, i) {
        dot.classList.toggle('active', i === currentIndex);
      });
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];
      var count = maxIndex() + 1;
      for (var i = 0; i < count; i++) {
        var btn = document.createElement('button');
        btn.className = 'carousel-dot' + (i === 0 ? ' active' : '');
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        btn.dataset.index = i;
        btn.addEventListener('click', function () {
          currentIndex = parseInt(this.dataset.index, 10);
          updateCarousel();
        });
        dotsWrap.appendChild(btn);
        dots.push(btn);
      }
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; updateCarousel(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < maxIndex()) { currentIndex++; updateCarousel(); }
    });

    // Touch / swipe support
    var touchStartX = 0;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        if (diff > 0 && currentIndex < maxIndex()) { currentIndex++; }
        else if (diff < 0 && currentIndex > 0)    { currentIndex--; }
        updateCarousel();
      }
    }, { passive: true });

    // Recalculate on resize
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        visibleCount = getVisible();
        if (currentIndex > maxIndex()) currentIndex = maxIndex();
        buildDots();
        updateCarousel();
      }, 150);
    });

    buildDots();
    updateCarousel();
  }

  /* ---- ACTIVE NAV LINK HIGHLIGHT ---- */
  var currentPath = window.location.pathname;
  document.querySelectorAll('.nav-link').forEach(function (link) {
    var href = link.getAttribute('href') || '';
    if (href === '/' && currentPath === '/') {
      link.classList.add('active');
    } else if (href !== '/' && href !== '/#shows' && currentPath.indexOf(href) === 0) {
      link.classList.add('active');
    }
  });

})();
/* ============================================================
   CART DRAWER
============================================================ */
window.DPHCart = (function () {
  var drawer  = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-overlay');
  var body    = document.getElementById('cart-drawer-body');
  var footer  = document.getElementById('cart-drawer-footer');
  var countEl = document.getElementById('nav-cart-count');
  var cartBtn = document.getElementById('nav-cart-btn');

  function open()  {
    drawer.classList.add('open');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('open');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCount(count) {
    countEl.textContent = count;
    countEl.classList.toggle('visible', count > 0);
  }

  function renderCart(cart) {
    updateCount(cart.item_count);
    body.innerHTML = '';

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-empty-msg">Your cart is empty.</p>';
      footer.style.display = 'none';
      return;
    }

    cart.items.forEach(function (item) {
      var el = document.createElement('div');
      el.className = 'cart-item';
      el.innerHTML =
        '<img class="cart-item-img" src="' + (item.image ? item.image : '') + '" alt="' + item.title + '">' +
        '<div>' +
          '<p class="cart-item-title">' + item.product_title + '</p>' +
          (item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="cart-item-variant">' + item.variant_title + '</p>' : '') +
          '<p class="cart-item-price">' + formatMoney(item.final_line_price) + '</p>' +
          '<div class="cart-item-qty">' +
            '<button class="cart-qty-btn" data-key="' + item.key + '" data-delta="-1">−</button>' +
            '<span class="cart-qty-num">' + item.quantity + '</span>' +
            '<button class="cart-qty-btn" data-key="' + item.key + '" data-delta="1">+</button>' +
          '</div>' +
        '</div>' +
        '<button class="cart-item-remove" data-key="' + item.key + '" aria-label="Remove">✕</button>';
      body.appendChild(el);
    });

    document.getElementById('cart-subtotal-price').textContent = formatMoney(cart.total_price);
    footer.style.display = 'block';
  }

  function fetchCart(cb) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (cb) cb(); });
  }

  function updateItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(renderCart);
  }

  /* Event delegation for qty +/− and remove */
  body.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('.cart-qty-btn');
    var removeBtn = e.target.closest('.cart-item-remove');

    if (qtyBtn) {
      var key   = qtyBtn.dataset.key;
      var delta = parseInt(qtyBtn.dataset.delta, 10);
      var numEl = qtyBtn.parentElement.querySelector('.cart-qty-num');
      var newQty = Math.max(0, parseInt(numEl.textContent, 10) + delta);
      updateItem(key, newQty);
    }

    if (removeBtn) {
      updateItem(removeBtn.dataset.key, 0);
    }
  });

  /* Open/close */
  cartBtn.addEventListener('click', function (e) {
    e.preventDefault();
    fetchCart(open);
  });
  overlay.addEventListener('click', close);
  document.getElementById('cart-close-btn').addEventListener('click', close);

  /* Init count on page load */
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateCount(cart.item_count); });

  return { open: open, close: close, refresh: fetchCart };
})();